import { Plus } from "lucide-react";
import { Button } from "../../../../components/ui/common/button";
import { Card, CardContent } from "../../../../components/ui/common/card";
import { ProductRegisterViewModel } from "../types/productRegisterView.types";
import ProductUnitCard from "./ProductUnitCard";

interface ProductUnitFormCardProps {
  vm: ProductRegisterViewModel;
}

const EYEBROW_CLASS =
  "tw-text-[10px] tw-uppercase tw-tracking-wider tw-text-muted-foreground tw-font-medium";

/**
 * "ADD UNIT SIZES" card — matches the Lovable prototype's
 * `RegisterProductDialog` exactly: eyebrow + subtitle + "Add sales unit"
 * button in the header, then each sales-unit draft rendered as its own
 * live-editable card (`ProductUnitCard`) rather than an inline mini-form
 * that gets submitted into a separate table.
 */
const ProductUnitFormCard = ({ vm }: ProductUnitFormCardProps) => {
  return (
    <Card className="tw-p-0">
      <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-border tw-px-5 tw-py-3">
        <div>
          <span className={EYEBROW_CLASS}>Add unit sizes</span>
          <p className="tw-mt-0.5 tw-text-xs tw-text-muted-foreground">
            One product can carry multiple sales units — add a name, size and image for each.
          </p>
        </div>
        {vm.canAddUnit ? (
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="tw-h-8 tw-gap-1.5 tw-text-xs"
            onClick={vm.onAddUnit}
          >
            <Plus className="tw-h-3.5 tw-w-3.5" />
            Add sales unit
          </Button>
        ) : null}
      </div>
      <CardContent className="tw-flex tw-flex-col tw-gap-3 tw-p-4">
        {vm.salesUnits.map((_, index) => (
          <ProductUnitCard key={index} vm={vm} index={index} />
        ))}
      </CardContent>
    </Card>
  );
};

export default ProductUnitFormCard;
